/** Routeur unifié : public, authentification, portail pro (/pro), administration (/admin). Chaque module fournit ses routes. */
import { createBrowserRouter, Navigate, type RouteObject } from 'react-router';
import { LayoutAdmin, LayoutAuth, LayoutPro, LayoutPublic } from './layouts/Layouts';
import { RequireEspace } from '../shared/auth/session';
import { PageConnexion, PageEnrolementMfa, PageVerificationMfa } from '../features/auth/Connexion';
import { ErreurRoute, Page401, Page403, Page404, Page500 } from '../features/erreurs/Erreurs';
import { routesPublic } from '../features/public/routes';
import { routesAuthPublic } from '../features/auth/inscription/routes';
import { routesPro } from '../features/pro/routes';
import { routesProCompte } from '../features/pro/compte/routes';
import { routesAdminCommercial } from '../features/admin/commercial/routes';
import { routesAdminVentes } from '../features/admin/ventes/routes';
import { routesAdminLogistique } from '../features/admin/logistique/routes';
import { routesAdminSysteme } from '../features/admin/systeme/routes';

const aIndex = (r: RouteObject[]) => r.some((x) => x.index);

export const routes: RouteObject[] = [
  {
    errorElement: <ErreurRoute />,
    children: [
      {
        element: <LayoutPublic />,
        children: [
          ...routesPublic,
          ...(aIndex(routesPublic) ? [] : [{ index: true, element: <Navigate to="/catalogue" replace /> }]),
          { path: 'erreur/401', element: <Page401 /> },
          { path: 'erreur/403', element: <Page403 /> },
          { path: 'erreur/500', element: <Page500 /> },
        ],
      },
      {
        element: <LayoutAuth />,
        children: [
          { path: 'connexion', element: <PageConnexion /> },
          { path: 'connexion/mfa', element: <PageVerificationMfa /> },
          { path: 'connexion/enrolement-mfa', element: <PageEnrolementMfa /> },
          ...routesAuthPublic,
        ],
      },
      {
        path: 'pro',
        element: <RequireEspace espace="pro"><LayoutPro /></RequireEspace>,
        children: [...routesPro, ...routesProCompte, { path: '*', element: <Page404 /> }],
      },
      {
        path: 'admin',
        element: <RequireEspace espace="admin"><LayoutAdmin /></RequireEspace>,
        children: [...routesAdminCommercial, ...routesAdminVentes, ...routesAdminLogistique, ...routesAdminSysteme, { path: '*', element: <Page404 /> }],
      },
      { element: <LayoutPublic />, children: [{ path: '*', element: <Page404 /> }] },
    ],
  },
];

export const creerRouteur = () => createBrowserRouter(routes);
